import { ChevronDown } from "lucide-react";

const FormSelect = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  options = [],
  error,
  required = false,
  disabled = false,
  placeholder,
  ...props
}) => {
  const stateClasses = error
    ? "border-red-300 hover:border-red-400 focus:border-red-500 focus:ring-2 focus:ring-red-100"
    : "border-gray-200 hover:border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100";

  return (
    <div>
      {label && (
        <label
          htmlFor={name}
          className="block text-sm font-medium text-gray-600 mb-1.5"
        >
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <div className="relative">
        <select
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          className={`block w-full text-sm appearance-none rounded-md border bg-white px-3 pr-9 py-2 outline-none transition-colors
            ${stateClasses}
            ${disabled
              ? "bg-gray-100 text-gray-400 cursor-not-allowed border-gray-200"
              : !value
              ? "text-gray-400"
              : "text-gray-900"}
          `}
          {...props}
        >
          <option value="" className="text-gray-400">
            {placeholder ?? `Select ${label || "an option"}`}
          </option>
          {options.map((opt) => (
            <option
              key={opt.value || opt}
              value={opt.value || opt}
              className="text-gray-900"
            >
              {opt.label || opt}
            </option>
          ))}
        </select>

        <ChevronDown
          size={14}
          className={`pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 ${
            disabled ? "text-gray-300" : "text-gray-500"
          }`}
        />
      </div>

      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  );
};

export default FormSelect;
